import React, { Fragment, useEffect, useState } from "react";
import CartItem from "./CartItem";
import { useDispatch } from "react-redux";
import { fetchCartFinish, fetchCartInfo } from "../../actions/global";
import { useSelector } from "react-redux";
import { formattedPrice } from "../../utils";
import { redirectToRaiffeisenPayment } from "../../utils/raiffeisenPayment";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Cart = (props) => {
  const { hideModal } = props || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { cartList } = useSelector((state) => state.globalReducer);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(fetchCartInfo());
  }, [dispatch]);

  const handleSubmitCart = async () => {
    setLoading(true);
    try {
      // Pozivamo novi action koji vraća payment podatke
      const paymentData = await dispatch(fetchCartFinish(navigate, hideModal));
      redirectToRaiffeisenPayment(paymentData, {
        includeTokenFields: false,
        includeNotifyUrl: false,
      });
    } catch (err) {
      // greška je već tretirana u action-u
      console.log(err, "err");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (loading) {
      const overlay = document.createElement("div");
      overlay.className = "checkout-overlay";
      overlay.innerHTML = `
        <div class="checkout-spinner"></div>
        <p>${t("cart.processingPayment")}</p>
        <p class="overlay-subtext">${t("cart.pleaseWait")}</p>
      `;
      document.body.appendChild(overlay);
      return () => overlay.remove(); // očisti kad loading završi
    }
  }, [loading, t]);

  return (
    <div className="cart-modal-holder">
      <div className="cart-modal-title">
        <h1>{t("cart.title")}</h1>
        <div className="cart-modal-close-icon" onClick={hideModal}>
          <img src="/images/close.png" alt="" className="img-fluid" />
        </div>
      </div>
      <div className="cart-modal-container">
        <div className="cart-modal-table">
          <div className="cart-modal-table-items">
            {cartList?.items?.length === 0 && <h4>{t("cart.emptyCart")}</h4>}

            {cartList?.items?.map((item, index) => (
              <CartItem item={item} key={index} />
            ))}
          </div>
        </div>
        {cartList?.items?.length > 0 && (
          <Fragment>
            <div className="cart-modal-sum-price">
              <div className="cart-modal-total">
                <div className="cart-modal-total-title">{t("cart.total")}</div>
                <div className="cart-modal-total-value">
                  {formattedPrice(cartList?.price)} RSD
                </div>
              </div>
            </div>
            <div className="cart-modal-checkout-submit">
              <div className="cart-modal-checkout">
                <button onClick={handleSubmitCart} disabled={loading}>
                  {t("cart.checkout")}
                </button>
              </div>
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default Cart;
